import { css } from 'styled-system/css';
import { jupiterContainer } from 'styled-system/patterns';

export const headerStyle = {
	header: css({
		pos: 'sticky',
		top: 0,
		zIndex: 'var(--header-zindex)',
		base: {
			color: '#2A2A2A',
			bgColor: '#FFFFFF',
		},
		_site42018: {
			color: '#FFFFFF',
			bgColor: '#070C26',
		}, // Macaubet
		_site42021: {
			color: '#FFFFFF',
			bgImage: 'linear-gradient(to bottom, #C80003, #9C0003)',
		}, // Aoncash
		_site42024: {
			color: '#FFFFFF',
			bgImage: 'linear-gradient(to bottom, #0A449B, #6895D0)',
		}, // ITCBet
		_site42156: {
			color: '#FFFFFF',
			bgColor: '#171717',
		}, // Bolanation
		_site42063: {
			color: '#FFFFFF',
			bgColor: '#000000',
			bgImage: 'url("/images/jupiter/42063/header-bg.jpg")',
			bgRepeat: 'no-repeat',
			bgPosition: 'center 26px'
		}, // 9bet
		_site42094: {
			color: '#000000',
			bgImage: 'url("/images/jupiter/42094/header-bg-soccer.png"), url("/images/jupiter/42094/header-bg.png")',
			bgRepeat: 'no-repeat, repeat-x',
			bgSize: 'auto 80px',
			bgPositionY: '26px',
		}, // M8Bola
		_site42102: {
			color: '#FFFFFF',
			bgImage: 'linear-gradient(to bottom, #FF6B31, #C24718)',
		}, // Q8bola
		_lgBelow: {
			// Macaubet info 改為在底部
			_site42018: {
				pb: '26px',
			}
		}
	}),
	info: css({
		h: '26px',
		bgColor: {
			base: '#333333',
		},
		color: {
			base: '#FFFFFF',
		},
		// Macaubet info 不顯示在上方，但仍要保留空間
		_site42018: {
			display: 'none',
		},
	}),
	infoContainer: jupiterContainer({
		justifyContent: 'center',
	}),
	appDownload: css({
		flex: 1,
	}),
	time: css({
		py: '3px',
		pr: '12px',
		fontWeight: '400',
	}),
	headerContainer: jupiterContainer({
		pos: 'relative',
		justifyContent: 'space-between',
		px: '12px',
		h: '80px',
		w: '100%',
		zIndex: 10,
		_site42018: {
			h: '106px',
			py: '18px',
			alignItems: 'flex-end',
		}, // Macaubet
	}),
	oldVersionButton: css({
		borderRadius: '6px',
		border: '1px solid #EC720E',
		background: 'linear-gradient(180deg, #FFF454 0%, #F70 100%)',
		h: '30px',
		lineHeight: '30px',
		px: '6px',
		display: 'flex',
		alignItems: 'center',
		gap: '3px',
		fontSize: '12px',
		fontWeight: '700',
		color: '#A30000',
		textAlign: 'center',
		cursor: 'pointer',
		flex: '0 0 auto',

		'& .icon': {
			w: '14px',
			h: '14px'
		}
	}),
	logo: css({
		h: '60px',
		'& img': {
			w: 'auto',
			h: '100%',
			maxH: '60px',
		},
		cursor: 'pointer',
	}),
	dropdown: css({
		'--dropdown-item-border': 'transparent',
		'--dropdown-item-text': 'colors.jupiter.grey.70',
		'&[data-open="true"]': {
			'& .dropdown__btn': {
				bgColor: 'jupiter.site.primaryDark',
			},
			'& .icon--arrow-down': {
				transition: 'trasform 200ms ease-in',
				transform: 'rotate(180deg)',
			},
		},
		'& .dropdown__btn': {
			borderRadius: '6px',
			bgColor: 'jupiter.site.primary',
			color: 'jupiter.site.primaryText',
			_supportHover: {
				_hover: {
					bgColor: 'jupiter.site.primaryLight',
				},
			}
		},
		'& .dropdown__current': {
			mr: '6px',
			color: 'jupiter.site.primaryText',
			overflow: 'visible',
		},
		'& .dropdown__container': {
			bgColor: 'jupiter.grey.10',
			boxShadow: '0 3px 9px rgba(0, 0, 0, .25)',
		},
		'& .dropdown__item': {
			minH: '30px',
			_supportHover: {
				_hover: {
					bgColor: 'jupiter.grey.20',
				},
			},
			'&[data-selected="true"]': {
				bgColor: 'transparent',
				color: 'jupiter.main.primary',
			},
		},
		'& .icon': {
			w: '16px',
			h: '16px',
		}
	}),
	dropdownButton: css({
		display: 'flex',
		alignItems: 'center',
		gap: '6px',
	}),
	account: css({
		display: 'flex',
		alignItems: 'center',
		columnGap: '12px',
	}),
	buttonGroup: css({
		display: 'flex',
		alignItems: 'center',
		columnGap: '6px',
	}),
	badge: css({
		pos: 'absolute',
		top: '-1px',
		right: '-1px',
		w: '8px',
		h: '8px',
		borderRadius: '8px',
		bgColor: {
			base: '#E73723',
			_site42018: '#E73723', // Macaubet
			_site42021: '#C4484D', // Aoncash
			_site42024: '#BC1410', // ITCBet
			_site42156: '#F38D05', // Bolanation
			_site42063: '#C80003', // 9bet
			_site42094: '#CC0000', // M8Bola
			_site42102: '#FFDD00'  // Q8bola
		},
		color: {
			base: '#FFFFFF',
			_site42102: '#1E1E1E'  // Q8bola
		}
	}),
	divider: css({
		w: '1px',
		h: '40px',
		bgColor: 'jupiter.grey.divider',
	}),
	balance: css({
		display: 'flex',
		flexDir: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		gap: '3px',
	}),
	balanceGroup: css({
		pos: 'relative'
	}),
	balanceText: css({
		textAlign: 'center',
	}),
	userButton: css({
		md: {
			display: 'flex',
			flexDir: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			cursor: 'pointer',
			_supportHover: {
				transition: 'all 200ms ease-in',
				_hover: {
					transform: 'scale(1.1)',
					color: 'jupiter.main.highlight',
				},
			},
		},
		_mdBelow: {
			display: 'none',
		}
	}),
	userIcon: css({
		pos: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		w: '24px',
		h: '24px',
		borderRadius: '24px',
		bgImage: 'linear-gradient(to bottom, #EDEDED, #FFFFFF)',
		borderWidth: '1px',
		borderColor: 'jupiter.common.white',
		color: 'jupiter.site.primaryFixed',
		boxShadow: '0 0 0 1px token(colors.jupiter.site.primaryFixed)',
		'& .icon': {
			w: '16px',
			h: '16px',
		},
	}),
	balancePanel: css({
		pos: 'absolute',
		top: '25px',
		right: 0,
		opacity: 0,
		transition: 'all 200ms ease-in',
		transform: 'translateY(-20px)',
		pointerEvents: 'none',
		_active: {
			pointerEvents: 'auto',
			opacity: 1,
			transform: 'translateY(0%)',
		},
		_mdBelow: {
			w: '100%',
			maxW: '375px',
			top: 'var(--header-height)',
		},
	}),
	refreshButton: css({
		_active: {
			'& .icon--refresh': {
				animation: 'loading 1s infinite linear',
			}
		}
	}),
	circle: css({
		position: 'absolute',
		top: '-19px',
		width: '60px',
		height: '60px',
		borderRadius: '50%',
		border: '6px solid rgba(235, 154, 59, 0.10)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		_ltr: {
			right: '-19px',
		},
		_rtl: {
			left: '-19px',
		},
		'&::before, &::after': {
			content: '""',
			position: 'absolute',
			inset: '-6px',
			borderRadius: '50%',
			border: '6px solid rgba(235, 154, 59, 0.3)',
			animation: 'ripple-out 1.6s infinite cubic-bezier(0.4, 0, 0.2, 1)'
		},
		'&::after': {
			animationDelay: '0.8s'
		}
	}),
	innerCircle: css({
		width: '48px',
		height: '48px',
		borderRadius: '50%',
		border: '6px solid rgba(235, 154, 59, 0.50)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	}),
	coreCircle: css({
		width: '36px',
		height: '36px',
		borderRadius: '50%',
		border: '3px solid #EB9A3B'
	}),
}